import type { ScreenBase } from "@frui.ts/screens";
import { Router } from "@frui.ts/screens";
import { Modules } from "config";
import LocalizationService from "services/localizationService";
import SecurityService from "services/securityService";
import SystemComponentsViewModel from "./systemComponents/systemComponentsViewModel";
import OutagesViewModel from "./outages/outagesViewModel";
import ModuleViewModel from "../moduleViewModel";
import DeadLetterTopicsViewModel from "./deadLetterTopics/deadLetterTopicsViewModel";
import KiosksViewModel from "./kiosks/kiosksViewModel";
import EmailBlacklistsViewModel from "./emailBlacklist/emailBlacklistsViewModel";

@Router.registerRoute({
  route: Modules.administration,
  name: Router.Self,
  children: [SystemComponentsViewModel, KiosksViewModel, OutagesViewModel, DeadLetterTopicsViewModel, EmailBlacklistsViewModel],
})
export default class AdministrationViewModel extends ModuleViewModel<ScreenBase> {
  protected readonly module = Modules.administration;

  constructor(
    protected localizationService: LocalizationService,
    private securityService: SecurityService,
    private systemComponentsViewModel: SystemComponentsViewModel,
    private kiosksViewModel: KiosksViewModel,
    private deadLetterTopicsViewModel: DeadLetterTopicsViewModel,
    private outagesViewModel: OutagesViewModel,
    private emailBlacklistsViewModel: EmailBlacklistsViewModel
  ) {
    super();
    this.navigationName = this.module;

    if (this.securityService.allowToEntity("systemComponent")) {
      this.children.push(this.systemComponentsViewModel);
    }

    if (this.securityService.allowToEntity("outage")) {
      this.children.push(this.outagesViewModel);
    }

    if (this.securityService.allowToEntity("kiosk")) {
      this.children.push(this.kiosksViewModel);
    }

    if (
      this.securityService.allowToEntity("deadLetterTopicsSearch") &&
      this.securityService.allowToEntity("deadLetterTopicsActionSearch")
    ) {
      this.children.push(this.deadLetterTopicsViewModel);
    }

    if (this.securityService.allowToEntity("emailBlacklist")) {
      this.children.push(this.emailBlacklistsViewModel);
    }
  }
}
